module.exports = __webpack_public_path__ + "img/img_download_pangda.b9bcadb0.jpg";